import { Button, Checkbox } from 'antd';
import React, { useState } from 'react';
import { EaseModal } from '../../libs/EaseModal';
import { Text1, Text5 } from '../../styles';


const BannerModal = (props) => {
    const [isChecked, setIsChecked] = useState(false);
    const [isRedirecting, setIsRedirecting] = useState(false);
    const [cancel, setCancel] = useState(false)
    const renderTitle = () => {
        return (
            <Text1 className="d-block mb-3" strong>{props?.data?.on_click_settings?.confirm_title}</Text1>
        )
    };

    const toggleChecked=()=>{
        setIsChecked(!isChecked);
    };

    const redirectURL=()=>{
        setCancel(props.toggleBannerModal)
        setIsRedirecting(!isRedirecting)
        if (props?.data?.on_click_settings?.target == "_blank") {
            window.open(props?.data?.on_click_settings?.redirect_url)
        } else {
            window.location.href = props?.data?.on_click_settings?.redirect_url;
        }
        
    }

    return (
      <EaseModal
        width={750}
        title={false}
        visible={props?.visible}
        centered
        hideFooter
        onCancel={props?.toggleBannerModal}
      >
        <>
          {renderTitle()}
          <div
            style={{ fontSize: "12px", cursor: "pointer" }}
            onClick={toggleChecked}
          >
            {props?.data?.on_click_settings?.checkbox_settings?.visible ? (
              <Checkbox
                style={{ marginRight: "10px" }}
                checked={isChecked}
                autoFocus
              />
            ) : null}
            <Text5>{props?.data?.on_click_settings?.confirm_message}</Text5>
            <div className="mt-3 d-flex" style={{ justifyContent: "center" }}>
              <Button
                type="primary"
                disabled={
                  props?.data?.on_click_settings?.checkbox_settings?.required && props?.data?.on_click_settings?.checkbox_settings?.visible
                    ? !isChecked
                    : false
                }
                onClick={redirectURL}
                onChange={cancel}
              >
                Proceed
              </Button>
            </div>
          </div>
        </>
      </EaseModal>
    );
};

export { BannerModal };